// @flow

import removeOrderItem from '../../../Services/removeOrderItem';
import type { RemoveOrderItemParams } from '../../../types';

export default (params: RemoveOrderItemParams) => async (dispatch: Function) => dispatch(removeOrderItem(params))